<!--
 * @Author: pengyong
 * @Date: 2020-11-11 22:55:32
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-12 22:36:23
 * @Description: 展会静态页面,参考：https://www.ciftis.org/cn/xmfb/ysztyz/index.html
 * @FilePath: /exhibit/src/views/map/index.vue
-->
<template>
    <div class="map-wrapper">
        <div class="map-box">
            <img class="map-bg" src="https://www.ciftis.org/uiFramework/commonResource/image/2020080717562982878.jpg" alt="" />
            <div class="item" v-for="item in items" :key="item.url">
                <img class="item-img" :style="{ left: item.left, top: item.top }" :src="item.url" alt="" />
            </div>
        </div>
        <img
            @click="handleToPlane"
            src="https://www.ciftis.org/uiFramework/commonResource/image/2020081018310816878.png"
            alt=""
            class="plane-exhibition"
        />
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    left: " 5.8%",
                    top: "29.8%",
                    url: "https://www.ciftis.org/cn/imageDir/2020/08/2020080615524845183.png"
                }
            ]
        };
    },
    methods: {
        handleToPlane() {
            this.$router.push("/exhibition");
        }
    }
};
</script>

<style lang="scss" scoped>
.map-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .map-box {
        position: relative;
    }
    .map-bg {
        max-width: 100%;
    }
    .item-img {
        width: 14.4444%;
        position: absolute;
        -o-transition: all 0.5s ease-out 0s;
        -webkit-transition: all 0.5s ease-out 0s;
        -moz-transition: all 0.5s ease-out 0s;
        transition: all 0.5s ease-out 0s;
    }
    .plane-exhibition {
        width: 28.4722%;
        position: absolute;
        right: 0;
        top: 4.5%;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/map/index.vue